"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reporting = void 0;
exports.reporting = {
    headings: {
        jobStats: "Job Stats",
        wasteStreamStats: "Waste Stream Stats",
    },
};
